import { CalEventFieldType } from '../constants/cal-event-field-type.js';
export const RULE_TYPES = ['requiredIf', 'visibleIf', 'defaultValueIf', 'addTagIf'];
export const RULE_TYPE_SET = new Set(RULE_TYPES);
/** Settable core gates a requiredIf/defaultValueIf rule may target. */
export const SETTABLE_CORE_FIELD_IDS = [
    'needsApproval',
    'checkInRequired',
    'underReviewRequired',
    'photoRequired',
];
/** Read-only core state a rule may condition on but never target. */
export const DERIVED_CORE_FIELD_IDS = [
    'assigneeCount',
    'hasOnSiteReps',
    'promotionLinked',
];
/** Every core field id, settable or derived — the single source both the validator and evaluator use. */
export const CORE_FIELD_ID_SET = new Set([
    ...SETTABLE_CORE_FIELD_IDS,
    ...DERIVED_CORE_FIELD_IDS,
]);
/** Sentinel `defaultValueIf` value meaning "whoever submits the form" — resolved by the caller. */
export const DEFAULT_TO_ACTOR = '__DEFAULT_TO_ACTOR__';
/** Operators the builder UI may offer for a given field's kind — an invalid pairing is unrepresentable. */
export const FIELD_TYPE_OPERATORS = {
    [CalEventFieldType.TEXT]: ['eq', 'isSet', 'isEmpty'],
    [CalEventFieldType.NUMBER]: ['eq', 'gt', 'gte', 'lt', 'lte'],
    [CalEventFieldType.DATE]: ['eq', 'before', 'after'],
    [CalEventFieldType.SELECT]: ['eq', 'in'],
    [CalEventFieldType.ENTITY_REF]: ['isSet', 'isEmpty'],
    [CalEventFieldType.SYSTEM_TIMESTAMP]: ['isSet'],
    [CalEventFieldType.PER_PRODUCT_NUMBER]: [],
};
/** Operators valid for a core field; only DERIVED_CORE_FIELD_IDS are never a rule target. */
export const CORE_FIELD_OPERATORS = {
    needsApproval: ['eq'],
    checkInRequired: ['eq'],
    underReviewRequired: ['eq'],
    photoRequired: ['eq'],
    promotionLinked: ['eq'],
    assigneeCount: ['eq', 'gt', 'gte', 'lt', 'lte'],
    hasOnSiteReps: ['eq'],
};
/** Parses a Date, ISO string, or epoch number into a comparable instant; undefined if unparseable. */
export function toComparableDate(value) {
    if (value instanceof Date || typeof value === 'string' || typeof value === 'number') {
        const time = new Date(value).getTime();
        return Number.isNaN(time) ? undefined : time;
    }
    return undefined;
}
//# sourceMappingURL=rule-types.js.map